<!-- IS Header -->
<ui-external-header
  currentSiteName="Startup Hub"
  [adminRouterLink]="auth.perm('ap-access') ? '/admin' : ''"
></ui-external-header>

<!-- Header -->
<ui-header
  #header
  logo="assets/img/logo.svg"
  [items]="menuItems"
  [showMobileMenu]="false"
  [isLogged]="auth.isLogged"
  [userName]="auth.user.name || ''"
  [userAvatar]="avatar"
  [notificationCount]="auth.notificationCount"
  [notificationsButton]="auth.isLogged"
  [notificationResolver]="resolveNotifications"
  (onLogin)="onLogin()"
  (onRegister)="onRegister()"
></ui-header>
<!--<st-header></st-header>-->

<div class="content">
  <router-outlet/>
</div>

<!-- Serenity button -->
@if (auth.perm('ap-access') && auth.serenity_token) {
  <button class="btn-serenity" (click)="openSerenityWidget()">Ask AI</button>
}

<!-- Footer -->
@if (isFooter()) {
  <st-footer></st-footer>
}

<!-- Modals -->
@for (m of modal.modals(); track $index) {
  <ui-modal [data]="m" [style.z-index]="100 + $index" [style.view-transition-name]="'modal' + $index"></ui-modal>
}